export default __webpack_public_path__ + "d9f435dbcd85bf48771e8d78502081b8.png";